import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-not-active-tab',
  templateUrl: './salvage-not-active-tab.component.html',
})
export class SalvageNotActiveTabComponent {
  @Input() context!: SalvageTabContext;
}
